import RouterUtils from '../routing/RouterUtils';
import { PsRoutes } from '../routing/Routes';

export class PsDocumentRouteGenerator {

    generateRoute(document, isMyContractors) {
        const currentPathname = window.document.location.pathname;
        const isMyContractorsPath = isMyContractors === undefined
            ? currentPathname.includes('mis-contratistas')
            : isMyContractors;

        return isMyContractorsPath
            ? this._routeToMyContractors(document)
            : this._routeToMyOutsources(document);
    }

    _routeToMyContractors(document) {
        const documentId = document.id();
        const contractorId = document.contractorId();

        if ( document.hasWorkerId() ) {
            const workerId = document.workerId();

            return RouterUtils.generateRoute(
                PsRoutes.MY_CONTRACTORS_WORKERS_DOCUMENTS_DETAIL,
                { contractorId, documentId, workerId },
            );
        }

        if ( document.hasMachineId() ) {
            const machineId = document.machineId();

            return RouterUtils.generateRoute(
                PsRoutes.MY_CONTRACTORS_MACHINES_DOCUMENTS_DETAIL,
                { contractorId, documentId, machineId },
            );
        }

        return RouterUtils.generateRoute(
            PsRoutes.MY_CONTRACTORS_DOCUMENTS_DETAIL,
            { contractorId, documentId },
        );
    }

    _routeToMyOutsources(document) {
        const documentId = document.id();
        const outsourceId = document.outsourceId();

        if ( document.hasWorkerId() ) {
            const workerId = document.workerId();

            return RouterUtils.generateRoute(
                PsRoutes.MY_OUTSOURCES_WORKERS_DOCUMENTS_DETAIL,
                { outsourceId, documentId, workerId },
            );
        }

        if ( document.hasMachineId() ) {
            const machineId = document.machineId();

            return RouterUtils.generateRoute(
                PsRoutes.MY_OUTSOURCES_MACHINES_DOCUMENTS_DETAIL,
                { outsourceId, documentId, machineId },
            );
        }

        return RouterUtils.generateRoute(
            PsRoutes.MY_OUTSOURCES_DOCUMENTS_DETAIL,
            { outsourceId, documentId },
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/document/PsDocumentRouteGenerator.js